export const SHIPPING_COST = 10
